






























import Vue from 'vue'

export default Vue.extend({
  components: {
    ActivitiesDiary: () => import('./depression/cbt/activities-diary/DiaryEditor.vue'),
    ConflictsDiary: () => import('./depression/ipt/conflicts-diary/DiaryEditor.vue'),
    ReframingsDiary: () => import('./depression/cbt/reframings-diary/DiaryEditor.vue'),
    RelationshipsDiary: () => import('./depression/ipt/relationships-diary/DiaryEditor.vue'),
    StrategiesDiary: () => import('./depression/ipt/strategies-diary/DiaryEditor.vue'),
    ThoughtsDiary: () => import('./depression/cbt/thoughts-diary/DiaryEditor.vue'),
  },
})
